<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%; overflow: hidden">
      <div style="padding-top: 20px"></div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div style>
            <div style="display: inline-block; width: 70%">
              <el-select
                style="display: inline-block; width: 150px; margin-right: 10px"
                placeholder="请选择状态"
                v-model="searchStatus"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                style="display: inline-block; width: 35%"
                v-model="searchKeyword"
                @keyup.enter.native="onSearchTableData"
                placeholder="请输入用户姓名、电话、微信号"
              ></el-input>
              <el-button
                @click="onSearchTableData"
                style="
                  display: inline-block;
                  margin-left: 20px;
                  background-color: #1bb24b;
                "
                type="success"
                >搜索</el-button
              >
            </div>
            <div
              style="display: inline-block; text-align: right; width: 30%"
            ></div>
          </div>

          <div style="margin-top: 3%">
            <el-table
              :data="tableDataList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column
                prop="id"
                label="ID"
                sortable
                width="100"
              ></el-table-column>
              <el-table-column prop="username" label="微信名"></el-table-column>
              <el-table-column label="用户头像">
                <template slot-scope="scope">
                  <img
                    style="width: 50px; height: 50px"
                    :src="scope.row.imgUrl"
                  />
                </template>
              </el-table-column>

              <el-table-column label="默认姓名">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.deliveryDetail">
                    <div v-if="item.ifDefault == true">{{ item.name }}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="默认微信号">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.deliveryDetail">
                    <div v-if="item.ifDefault == true">{{ item.wechat }}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="默认电话">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.deliveryDetail">
                    <div v-if="item.ifDefault == true">{{ item.phone }}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="默认地址">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.deliveryDetail">
                    <div v-if="item.ifDefault == true">{{ item.address }}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="会员点数">
                <template slot-scope="scope">
                  <div>{{ scope.row.memberPoint }}</div>
                </template>
              </el-table-column>

              <el-table-column label="积分点数">
                <template slot-scope="scope">
                  <div>{{ scope.row.rewardPoint }}</div>
                </template>
              </el-table-column>

              <el-table-column label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.status != '关闭'">
                    {{ scope.row.status }}
                  </div>
                  <div v-else>禁止</div>
                </template>
              </el-table-column>

              <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'deliveryDetail')"
                    >收货信息</el-button
                  >
                  <!-- <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'member')"
                    >修改会员</el-button
                  > -->

                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'normal')"
                    >恢复</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'ban')"
                    >禁止微信号</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px">
            <el-pagination
              background
              :page-size="20"
              :current-page.sync="currentPage"
              layout="prev, pager, next"
              :total="tableDataTotal"
              @current-change="onFetchTableData"
            ></el-pagination>
          </div>
        </div>
      </div>

      <el-dialog
        title="禁止用户"
        :visible.sync="boolBanUser"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolBanUserClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onBanUserConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolBanUserClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="恢复用户"
        :visible.sync="boolNormalUser"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolNormalUserClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onNormalUserConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolNormalUserClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="用户收货信息"
        :visible.sync="boolDeliveryDetail"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolDeliveryDetailClose"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; width: 100%">
            <el-table
              border
              :data="currentData.deliveryDetail"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="phone" label="手机号"></el-table-column>
              <el-table-column prop="wechat" label="微信号"></el-table-column>
              <el-table-column prop="address" label="地址"></el-table-column>
              <el-table-column label="是否为默认地址">
                <template slot-scope="scope">
                  <div v-if="scope.row.ifDefault == true">默认地址</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDialogBoolDeliveryDetailClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >关闭</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="会员点数"
        :visible.sync="boolMember"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolMemberClose"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            会员点数
          </div>
          <el-input
            type="number"
            :min="0"
            style="display: inline-block; width: 70%"
            v-model="formMember.memberPoint"
          ></el-input>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onEditMemberConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolMemberClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "userList",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchStatus: "",
      searchKeyword: "",

      currentData: {},
      currentPage: 1,
      tableDataList: [],
      tableDataTotal: 0,

      boolBanUser: false,
      boolNormalUser: false,
      boolDeliveryDetail: false,
      boolMember: false,
      statusList: [
        { label: "正常", value: "正常" },
        { label: "禁止", value: "关闭" },
      ],
      formMember: {
        memberPoint: 0,
      },
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
  },
  methods: {
    // check if user login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },

    // search user table by name
    onSearchTableData() {
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchUserList", {
          keyword: this.searchKeyword,
          status: this.searchStatus,
          page: this.currentPage,
        })
        .then((res) => {
          console.log(res.data.data);
          this.tableDataList = res.data.data.data;
          this.tableDataTotal = res.data.data.total;
          this.fullscreenLoading = false;
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "member":
          this.boolMember = true;
          this.formMember.memberPoint = scope.row.memberPoint;
          break;
        case "deliveryDetail":
          this.boolDeliveryDetail = true;
          break;
        case "normal":
          this.boolNormalUser = true;
          break;
        case "ban":
          this.boolBanUser = true;
          break;
      }
    },

    // delivery detail
    onDialogBoolDeliveryDetailClose() {
      this.boolDeliveryDetail = false;
    },

    // ban user operation
    onDialogBoolBanUserClose() {
      this.boolBanUser = false;
    },
    onBanUserConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminChangeUserStatusById", {
          id: this.currentData.id,
          status: "关闭",
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.onFetchTableData();
          this.onDialogBoolBanUserClose();
        });
    },

    // normal user operation
    onDialogBoolNormalUserClose() {
      this.boolNormalUser = false;
    },
    onNormalUserConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminChangeUserStatusById", {
          id: this.currentData.id,
          status: "正常",
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.onFetchTableData();
          this.onDialogBoolNormalUserClose();
        });
    },

    // member operation
    onDialogBoolMemberClose() {
      this.boolMember = false;
    },

    onEditMemberConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminUpdateUserInfo", {
          id: this.currentData.id,
          memberPoint: this.formMember.memberPoint,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.onFetchTableData();
          this.onDialogBoolMemberClose();
        });
    },
  },
};
</script>

